import PropTypes from 'prop-types'
import React from 'react'
import { ThemeContext } from 'styled-components'

import HowToBlock from 'components/_special/HowToBlock'
import SectionWrapper from 'components/SectionWrapper'
import { Text } from 'styles/components/typography'

import party from './assets/bactarias_party.svg'
import { Image } from './styles'

/**
 * BHowCollect
 *
 * @param {object} props - properties of component
 * @returns {node} BHowCollect
 */
const BHowCollect = props => {
  const { data, index, isSquareHidden } = props
  const { colors } = React.useContext(ThemeContext)

  return (
    <SectionWrapper
      isOverflowHidden={true}
      classNameInner="pb-4"
      classNameWrapper="bg--gray--op-06"
    >
      <HowToBlock
        title={data.title}
        index={index}
        squareColor={colors.lilac}
        isSquareHidden={isSquareHidden}
      >
        <div className="row">
          <div className="col-12 col-md-5 col-lg-6 order-md-1">
            <Image alt="bacterias party" className="pb-2 pb-md-0" src={party} />
          </div>
          <div className="col-12 col-md-6 col-lg-5 offset-md-1 offset-lg-1 order-md-0">
            <Text
              className="with-inverted-links"
              dangerouslySetInnerHTML={{ __html: data.content }}
            />
          </div>
        </div>
      </HowToBlock>
    </SectionWrapper>
  )
}

BHowCollect.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isSquareHidden: PropTypes.bool,
}

BHowCollect.defaultProps = {
  isSquareHidden: false,
}

export default BHowCollect
